import React, { useCallback, useState } from 'react'

interface Position {
  top: number
  left: number
}

export const usePosition = <R extends HTMLDivElement>(
  containerRef: React.RefObject<R>,
  pickerRef: React.RefObject<HTMLDivElement>
) => {
  const [position, setPosition] = useState<Position>({ top: 0, left: 0 })

  const calculatePosition = useCallback(() => {
    if (!containerRef.current || !pickerRef.current) return

    const containerRect = containerRef.current.getBoundingClientRect()
    const pickerRect = pickerRef.current.getBoundingClientRect()

    let top = containerRect.bottom + window.scrollY
    let left = containerRect.left + window.scrollX

    if (top + pickerRect.height > window.innerHeight) {
      top = containerRect.top - pickerRect.height + window.scrollY
    }
    if (left + pickerRect.width > window.innerWidth) {
      left = window.innerWidth - pickerRect.width
    }

    // Only updates the position if it has changed
    setPosition((prevPosition) => {
      if (prevPosition.top === top && prevPosition.left === left) {
        return prevPosition
      }
      return { top, left }
    })
  }, [containerRef, pickerRef])

  return { position, calculatePosition }
}
